import React from 'react';
import ObjectSelectorPanel from 'components/ObjectSelectorPanel';
import { ShelfComposition } from 'lib/modelBuilder/constants';
import { HandleUserSelection } from 'containers/HandlesPanel/types';
import { useTranslation } from 'react-i18next';
import GenericObjectSelector from 'components/GenericObjectSelector';

interface Props {
  handlePositionSelected: HandleUserSelection[];
  selection: any;
  compositions: Set<ShelfComposition>;
  handleSelection: any;
  drawerPosition: number[];
}

const DrawersHandleSelection = ({
  handlePositionSelected,
  selection,
  handleSelection,
  drawerPosition,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-center py-1">
      {drawerPosition.map(pos => (
        <GenericObjectSelector
          key={pos}
          title={`${t('Drawer')} ${pos + 1}`}
          selected={handlePositionSelected.includes(pos)}
          onClick={(e: any) => selection(e, pos)}
          present={true}
          canAddNew
        />
      ))}
    </div>
  );
};

export default DrawersHandleSelection;
